
export class Nom {
    nom: string;
    primerCognom: string;
    segonCognom: string;
    nomComplet: string;
}

export class Nass {
    numero: string;
    cobertura: string; //tipusAfiliacio
    pensionista: string;
}

export class Direccio {
    tipusCarrer: string;
    nomCarrer: string;
    direccioComplerta: string;
    numero: string;
}

export class Residencia {
    direccio: Direccio;
    poblacio: string;
    ciutat: string;
    provincia: string;
    pais: string;
    autonomia: string;
    codiPostal: string;
    ambitResidencia: string;
}

export class Pacient {
    id: string;
    nass: Nass;
    cip: string;
    tipusDocId: string;
    docId: string;
    nomPacient: Nom;
    telefon: string;
    sexe: string;
    dataNaixement: string;
    dataNaixementAsComment: string;
    residencia: Residencia;
    upo: string;
    abs: string;
    cap: string;
}

export class Colegiat {
    tipus: string;
    provincia: string;
    numero: string;
    codiValidacio: string;
}

export class Metge {
    tipus: string;
    rol: string;
    nomMetge: Nom;
    codiColegiat: Colegiat;
}

export class Diagnostic {
    codi: string;
    descripcio: string;
    codificacio: Nom;
    durada: number;
}

export class Episodi {
    tipus: string;
    id: string;
    dataEntrada: string;
    horaEntrada: string;
    origen: string;
    procedencia: string;
    ubicacio: string;
    unitatInfermeria: string;
    metge: Metge;
    diagnostics: Diagnostic[];
    financiacio: string;
    garant: string;
    activitat: string;
    dataActivitat: string;
}

export class ICAM {
    limitacioCapacitatFuncional: string;
    diagnostic: Diagnostic;
    empresa: string;
    cno: string;
    llocTreball: string;
    dataEfectes: Date;
    dataAlta: Date;
    dataPart: Date; // només per activitat PART si es posa manualment
    dataSortida: Date; // data i hora en la que el pacient ja no arriba a la llista. Data de sortida de l'hospital
    observacions: string;
    dataExpedicioComunicat: Date;
    codiIndicadorMalaltia: string;
    codiSituacioLaboral: string;
    episodiICAM: string;
    codiContingencia: string;
    duradaEstimada: string;
    duradaAcumulada: string;
    dataProperaVisita: string;
    tipusAssistencia: string;
    indicadorDarrerComunicatTrasllat: string;
    indModificacio: string;
    codiComunicatMod: string;
    potBaixa: boolean;
    potConfirmacio: boolean;
    potAlta: boolean;
    estat: string;
    motiuEstat: string;
    actualitzat: Date; // data hora que s'ha arribat a la llista per última vegada
    resultat: string;
    codiComunicat: string;
    codiEpisodiICAM: string;
    missatgeICAM: string;
    documentICAM: string;
}

export class PacientModel {
    id: string;
    pacient: Pacient;
    episodi: Episodi;
    icam: ICAM;
    present: boolean;
    historic: boolean;
}

export class Ocupacio {
    codi: string;
    nom: string;
}

export enum EstatPacient {
    Nou = "Nou",
    Pendent = "Pendent",
    NoApte = "NoApte",
    Rebutjat = "Rebutjat",
    EnviatOK = "EnviatOK",
    EnviatKO = "EnviatKO",
    ConfirmatOK = "ConfirmatOK",
    ConfirmatKO = "ConfirmatKO",
    AnulatOK = "AnulatOK",
    AnulatKO = "AnulatKO",
    MaterIT = "MaterIT",
    MaterAltaIT = "MaterAltaIT",
    MaterAltaKO = "MaterAltaKO",
    Error = "Error",
}

export class Actualitzacio {
    id: string;
    estat: string;
    ultima: Date;
}

export enum Activitats {
    INGRES = "INGRES",
    CMA = "CMA",
    PART = "PART",
}

export enum MotiuEstat {
    SenseDiagnostic = 'SenseDiagnostic',
    MetgeResident = 'MetgeResident',
    ProcesITObert = 'ProcesITObert',
    MaterITActiva = 'MaterITActiva',
    MaterITActivaPropia = 'MaterITActivaPropia',
    MaterITAltaPropia = 'MaterITAltaPropia',
    MaterITAlta = 'MaterITAlta',
    NoTitular = 'NoTitular',
    Pensionista = 'Pensionista',
    NoPermetICAM = 'NoPermetICAM', 
    ErrorDades = 'ErrorDades',
    Desconegut = 'Desconegut',
  }
  
